import { API_ENDPOINTS } from '@/shared/api/endPoints';

interface SendLeadFormDataPayload {
  name: string;
  submitDate: string;
  referer: string;
  phone: string;
  email: string;
  purpose?: string;
  product?: string;
  company?: string;
  city?: string;
  clientId?: string;
}

export default async function sendLeadFormData(
  formData: SendLeadFormDataPayload,
) {
  const data = await fetch(`${API_ENDPOINTS.LEAD_FORM}`, {
    method: 'POST',
    body: JSON.stringify(formData),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return data.json();
}
